import React, { CSSProperties } from 'react';

import { createClassName } from 'utils/createClassName';

import './inlineLayoutStyles.scss';

type Props = {
  gap: string;
};

export const InlineLayout: React.FC<Props> = (props) => {
  const { children, gap } = props;

  const style = React.useMemo<CSSProperties>(() => {
    return {
      visibility: 'initial', // Бесполезное правило, чтобы типизация не ругалась.
      '--inlineLayoutGap': gap,
    };
  }, [gap]);

  const createElementClassName = createClassName('inlineLayout');

  return (
    <div className={createElementClassName('wrapper')} style={style}>
      {children}
    </div>
  );
};
